import { apiClient } from "api/ApiClient";
import { User } from "api/entities/User";

/**
 * ユーザ情報取得
 */
const getUser = async (): Promise<User> => {
    try {
        const response = await apiClient.post(`/user`);

        let date = response?.data;
        const user: User = {
            id: date.id,
            laboid: date.laboid,
            signin: date.signin,
        };
        return Promise.resolve(user);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
        return {
            id: ``,
            laboid: ``,
            signin: false,
        };
    }
};

/**
 * ユーザ詳細情報取得
 */
const getUserDetail = async (): Promise<any> => {
    try {
        const response = await apiClient.get(`/user/detail`);

        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
    }
};

export const UserApi = {
    getUser,
    getUserDetail,
};

